import React from 'react';
import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import tw from '../styles/tailwind';
import Text from './Text';


type BrandToastProps = {
  message?: string | React.ReactNode;
  type?: string;
};

/**
 * Estilo unificado de toasts DingDong: tarjeta blanca redondeada con sombra,
 * ícono y acento de color de marca según el tipo. Se usa vía `renderToast`
 * en el ToastProvider (App.tsx), así aplica a TODOS los toasts.
 */
export default function BrandToast({ message, type }: BrandToastProps) {
  const accent =
    type === 'success' ? tw.color('primary') :
    (type === 'danger' || type === 'warning') ? tw.color('red') :
    tw.color('secondary');

  const icon: any =
    type === 'success' ? 'checkmark-circle' :
    (type === 'danger' || type === 'warning') ? 'alert-circle' :
    'information-circle';

  return (
    <View
      style={tw.style(
        `bg-white rounded-2xl px-4 py-3 mt-2 mx-4 row items-center shadow-lg border border-gray-100 self-center`,
        { maxWidth: 420 },
      )}
    >
      <Ionicons name={icon} size={22} color={accent} style={tw`mr-3`} />
      <Text style={tw`text-secondary font-500 flex-1`}>{message}</Text>
    </View>
  );
}
